<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 mydiv" id="the-golden-moon">
<h1>The Golden Moon</h1>
<p>I remember when we used to talk</p>
<p>The sun was up and it seemed to shine all night through</p>
<p>We walked side by side</p>
<p>We laughed and used to cry</p>
<p>It seemed there was nothing we couldn’t do</p><br/>
<p>And now it’s all become winter and the summers gone</p>
<p>I don’t know what is left to do</p>
<p>I can’t stop thinking about you</p>
<p>And all the things we did</p>
<p>Hoping you will drop by and say hello</p><br/>
<p>The dark nights are drawing in</p>
<p>And now it’s just the endless cold</p>
<p>Even now I’m thinking of the coming snow</p>
<p>Nothing is the same, I only have myself to blame</p>
<p>And every day it looks like it’s going to rain</p><br/>
<p>So I took a walk out in the dark,</p>
<p>I don’t know why just walked the golden moon</p>
<p>Thought I might see you there and perhaps</p>
<p>We could talk a while</p>
<p>Never thought it would be such a long time</p><br/>
<p>I wish I could pull myself out of it</p>
<p>I wish it could be spring again</p>
<p>Oh I just have to wait a little more</p><br/>
<p>Winter’s here and now I’m dead inside</p>
<p>Not heard a word or seen your face in a while</p>
<p>I’m beginning to forget, but I am really not the same</p>
<p>I’m just a shadow of what could have begun</p><br/>
<p>I’ve been looking at the news</p>
<p>Keep trying to hang on, but you know I’m not myself</p>
<p>Absence is something I just can’t do</p>
<p>Oh, I wish I could be taught</p>
<p>I wish I could be strong</p>
<p>But the truth is I just can’t live without you</p><br/>
<p>So I took a walk out in the dark,</p>
<p>I don’t know why just walked the golden moon</p>
<p>Thought I might see you there and perhaps</p>
<p>We could talk a while</p>
<p>Never thought it would be such a long time</p><br/>
<p>Every day I watch all the flowers bloom</p>
<p>And I tell myself you’re each and every one</p>
<p>I pick them up and smell them</p>
<p>I put them to my mouth and taste them</p>
<p>I’m just going to have to make it work</p><br/>
<p>Oh God works in mysterious ways</p>
<p>I find myself picking up the phone to say hello</p>
<p>And when he answered I was not deterred</p>
<p>So I said her name and began to pray</p><br/>
<p>Her voice I did yearn</p>
<p>And I remember how my heart thumped</p>
<p>It did so hard I could hardly hear</p>
<p>And just when I thought all was lost</p>
<p>I heard her voice and that soft hello</p><br/>
<p>She said, hello, it’s me, I’ve been really busy</p>
<p>I wanted to call you but I felt uneasy</p>
<p>I guess I just left it far too long</p><br/>
<p>I’ve been walking out in the dark,</p>
<p>I don’t know why just walked the golden moon</p>
<p>Thought I might see you there and perhaps</p>
<p>We could talk a while</p>
<p>Never thought it would be such a long time</p><br/>
<p>Oh I smiled and smiled and smiled</p>
<p>I feel I climbed a broken hill</p>
<p>I said it’s ok, it’s all right</p>
<p>I wish you were here every night</p><br/>
<p>I think of all the words we said</p>
<p>I repeat them in my head</p>
<p>I try to sleep but they won’t go away</p><br/>
<p>So I took a walk out in the dark,</p>
<p>I don’t know why just walked the golden moon</p>
<p>Thought I might see you there and perhaps</p>
<p>We could talk a while</p>
<p>Never thought hellos could be so easy</p>
<p>Just visit me when you want to walk and talk.</p><br/>
<p>Chorus:</p>
<p>So I took a walk out in the dark,</p>
<p>I don’t know why just walked the golden moon</p>
<p>Thought I might see you there and perhaps</p>
<p>We could talk a while</p>
<p>Never thought it would be such a long time.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?2e69e4ce